<template>
	<div>
		<div class="mengCeng">
			<img src="@/assets/images/mencheng.png" class="w-100 mengCengtu" alt="">
		</div>
		<!-- breadcrumb area -->
		<div class="breadcrumb-area breadcrumb-padding bg-img" :style="{backgroundImage:`url(${bgImg})`}">
		    <div class="container">
		        <div class="breadcrumb-content text-center">
		            <h2>优惠详情</h2>
		        </div>
		    </div>
		</div>
		<!-- Project area -->
		<div class="section section-padding">
		    <div class="container">
		        <div class="row row-cols-lg-2 row-cols-md-2 row-cols-1">
		            <div class="col">
		                <div class="project-details-img-wrap">
		                    <div class="project-details-img mb-6" v-for="(item,index) in imgInfo" :key="item.id">
		                        <img :src="item | imgfilter" alt="Project Image">
								<div style="position: absolute;" v-for="(tag,tai) in item.tagInfo" :key="tag.id"
									:style="{left:parseInt((570/item.width)*tag.x) + 'px',top:  parseInt((570/item.width)*tag.y)+ 'px'}"
								>
									<span class="dian"></span>
									<div class="mov-tag" style="cursor: pointer;" @click="toProductTag(tag)">
										{{tag.name}}
									</div>
								</div>
		                    </div>
		                </div>
		            </div>
		            <div class="col sidebar-active">
		                <div class="project-wrapper-sticky">
		                    <div class="project-details-content mb-5 mb-md-8">
		                        <h5 style="color: #4A4A4A;" v-if="promoInfo.merchantInfo">{{promoInfo.merchantInfo.company}}</h5>
		                        <div class="project-details-list-content"> 
		                            <span class="tag" v-for="(tag,tai) in promoInfo.tags" :key="tai">{{tag}}</span>
		                        </div>
		                        <p v-if="promoInfo.merchantInfo">案例地址：{{promoInfo.merchantInfo.detailed_address}}</p>
								
								<div class="d-flex" style="margin-top: 30px;justify-content: space-between;">
									<div class="d-flex" style="align-items: center;">
										<Icon class="c-00" v-if="isLike" style="cursor: pointer;" size="30" color="#ff495e" type="ios-heart" />
										<Icon class="c-00" v-else style="cursor: pointer;" size="30" type="ios-heart-outline" @click="likeClick(promoInfo)" />
										<span style="margin-left: 10px;">{{promoInfo.like_count}}</span>
									</div> 
									<div class="d-flex" style="align-items: center;">
										<Button type="success" @click="modalShowFlag">立即预约</Button>
									</div> 
								</div>
								
		                    </div>
		                    <div class="project-details-info modify">
								<h5 style="color: #4A4A4A;" class="title">活动描述</h5>
								<div style="margin-top: 20px;margin-left: 30px;">
									<div class="text">{{promoInfo.description}}</div>
								</div>
		                    </div>
							
		                    <h5 style="color: #4A4A4A;" class="title">活动内容</h5>
							<div class="text" v-html="promoInfo.content"></div>
		                </div>
		            </div>
		        </div>
		    </div>
		</div>
        <Modal
            v-model="modalShow"
            title="预约"
            >
            <Form ref="form" :model="formData"  :rules="rules" :label-width="100">
                <Row :gutter="24" type="flex">
                    <Col span="22" class="ivu-text-left">
                        <FormItem label="用户名称：" prop="name">
                            <Input v-model="formData.name" placeholder="**女士/先生"></Input>
                        </FormItem>
                    </Col>
                </Row>

                <Row :gutter="24" type="flex">
                    <Col span="22" class="ivu-text-left">
                        <FormItem label="电话号码："  prop="phone">
                            <Input @on-keyup="clearBlank" v-model="formData.phone" placeholder="请输入您的电话号码"></Input>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button @click="modalCancel">取消</Button>
                <Button @click="modalConfirm">确定</Button>
            </div>
        </Modal>
		<div class="inapp">
			<span @click="getHref">在APP中打开</span>
		</div>
		
	</div>
</template>

<script>
	import { getCookies } from '@/libs/util'
	import {
		getPromoInfo,
		getProjectProductList,
		promoReserve,
		promoLike,
		CollectAdd,
		CollectDel,
		projectView 
	 } from '@/api'
	 export default {
	   name: 'app',
	   data() {
			return {
				userInfo: {},
				pid: 0,
				commentText: '',
				bgImg: require('../../static/images/banner/banner-3.jpg'),
				imgInfo: [],
				promoInfo: {},
				dataStr:'',
				
				projectProductList: [],
				projectCommentList: [],
				opening: false,
				
				timer: null,
                modalShow: false,
                formData: {
					name: '',
					phone: ''
				},
				isLike: '',
                rules: {
					name: [
						{required: true, message: '您的称呼不能为空', trigger: 'blur'},
					],
					phone: [{pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/, required: true, message: '请输入正确的电话号码',trigger: 'change'
					}]
				},
			}
		},
		created() {
		    this.getDetailData() 
		    this.getProjectProductList()
			this.getprojectView()
		},
		mounted() {
			this.userInfo = this.$store.state.app.userInfo
		},
		computed: {
			isLogin() {
			  return getCookies("webtoken");
			},
		},
		methods:{
			// 电话号码输入非数字回退
			clearBlank(e){
				let char = e.key.replace(/[^(\-|\+)?\d+(\.\d+)]/g,'')
				if (!char) this.formData.phone = this.formData.phone.substring(0,this.formData.phone.length - 1)
			},
			modalConfirm() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
						console.log(this.promoInfo);
						const postData = {
							prom_id: this.promoInfo.id,
							mer_id: this.promoInfo.merchantInfo.id,
							name: this.formData.name,
							phone: this.formData.phone
						}
                        promoReserve(postData).then(res=> {
							alert('预约成功')
						})
                    } else {
                        this.$Message.error('请输入正确的信息！');
                    }
                })
			},
            modalShowFlag () {
				if(!this.isLogin) {
					alert('请登录后操作')
					return false
				}
                this.modalShow = true;
            },
			modalCancel(){
				this.modalShow = false
			},

			getHref() {
				let that = this
				var ua = navigator.userAgent.toLowerCase();
				var isWeixin = ua.indexOf('micromessenger') != -1;
				let mengCeng = document.querySelector('.mengCeng');
				let mengCengtu = document.querySelector('.mengCengtu');
				if (isWeixin) {
					mengCeng.style.height = "100vh";
					mengCengtu.style.display = "block";
				    return;
				}
				let params = 'pid='+ this.$route.params.id + '&type=' + 3

				that.opening = true
				//android终端
				let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1; 
				//ios终端
				let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
				if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
					console.log('ios')
					window.location = "zhuke://" + params
					that.timer = setTimeout(function () { //  未安装的情况
						that.opening = false
						//  跳转app store
						let r = confirm("未安装APP? 是否去App store查看")
						if (r) {
							window.location = 'https://apps.apple.com/cn/app/筑壳/id1624314273'
						}
				    }, 3000);
					mengCeng.style.height = "0vh";
					mengCengtu.style.display = "none";
				} else {
					let ifr = document.createElement('iframe');
					ifr.src ="zhuke://" + params;
					ifr.style.display = 'none';
					document.body.appendChild(ifr);
					that.timer = window.setTimeout(function () {  //  未安装的情况
						that.opening = false
						document.body.removeChild(ifr);
						//  提示下载
						let r = confirm("未安装APP? 是否下载")
						if (r) {
							window.location = 'https://www.zikkkk.com/downloadApp/筑壳.apk'
						}
					}, 3000)
					mengCeng.style.height = "0vh";
					mengCengtu.style.display = "none";
				}
			},
			
			toProductTag(data) {
				switch (data.tag_type){
					case 1:
						let routeUrl = this.$router.resolve({
							path: '/merchantDetail/'+data.zk_id,
						  })
						  window.open(routeUrl.href, '_blank')
						break;
					default:
						if(data.is_real){//真实产品
							let routeUrl2 = this.$router.resolve({
								path: '/productDetail/'+data.product_id,
							  })
							  window.open(routeUrl2.href, '_blank')
						} else {
							let routeUrl3 = this.$router.resolve({
								path: '/merchantDetail/'+data.zk_id,
							  })
							  window.open(routeUrl3.href, '_blank')
						}
						break;
				}
			},
			
			// 产品详情
			toProduct(data) {
				switch (data.tag_type){
					case 1:
						let routeUrl = this.$router.resolve({
							path: '/merchantDetail/'+data.productInfo.zk_id,
						  })
						  window.open(routeUrl.href, '_blank')
						break;
					default:
						if(data.productInfo.is_real){//真实产品
							let routeUrl2 = this.$router.resolve({
								path: '/productDetail/'+data.product_id,
							  })
							  window.open(routeUrl2.href, '_blank')
						} else {
							let routeUrl3 = this.$router.resolve({
								path: '/merchantDetail/'+data.productInfo.zk_id,
							  })
							  window.open(routeUrl3.href, '_blank')
						}
						break;
				}
				
			},
			
			// 收藏
			collectsave(item) {
				let that = this
				if(!this.isLogin) {
					alert('请登录后操作')
					return false
				}
				if(item.save_flag){
					let param={
						type: 0,
						pr_id:item.id
					}
					CollectDel(param).then((res)=>{
						if(res.status==200){
							that.$message.success("取消收藏")
							item.save_flag = 0
							item.save_count--
						}
					})
				}else{
					let param={
						type: 0,
						pr_id:item.id
					}
					CollectAdd(param).then((res)=>{
						if(res.status==200){
							that.$message.success("收藏成功")
							item.save_flag = 1
							item.save_count++
						}
					})
				}
			},		
			
			// 获取案例详情
			async getprojectView() {
			  const res = await projectView({
				  type:3
			  })
			},
			
			// 获取案例详情
			async getDetailData() {
			  const res = await getPromoInfo({
				  id: this.$route.params.id
			  })
			  let data = res.data || {}
			  this.imgInfo = data.info.images
			  
			  if(data.info.tags) data.info.tags = data.info.tags.split(',') || []
			  this.isLike = data.is_like
			  this.promoInfo = data.info
			},
			
			// 获取案例产品
			async getProjectProductList() {
			  const res = await getProjectProductList({
				  project_id: this.$route.params.id
			  })
			  let data = res.data.data || []
			  this.projectProductList = data
			},

            // 弹窗关闭
            handleClose(done) {
                this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => {});
            },
			
		
			
			likeClick(value){
				if(!this.isLogin) {
					alert('请登录后操作')
					return false
				}
				promoLike({prom_id: value.id}).then(res=> {
					this.promoInfo.like_count ++
					this.isLike = true
				})
				
			},
		}
	}
</script>

<style>
	.mengCengtu {
		display: none;
	}
	
	.w-100 {
		width: 100%;
	}
	
	body {
		position: relative;
	}
	
	/* 蒙层 */
	.mengCeng {
		position: fixed;
		top: 0;
		left: 0;
		opacity: 0.8;
		width: 100vw;
		height: 0vh;
		z-index: 999;
		background-color: #323232;
	}
	.text {
		padding: 30px 0px 30px  0px;
	}
</style>
